import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Login from './pages/Login'
import Register from './pages/Register'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import TestReset from './pages/TestReset'
import Dashboard from './pages/Dashboard'
import ConfiguracoesModulos from './pages/ConfiguracoesModulos'
import ConfiguracoesPortalAtendimento from './pages/Configuracoes/PortalAtendimento'
import Usuarios from './pages/Usuarios'
import LeitorArquivos from './pages/LeitorArquivos'
import PasiGPT from './pages/PasiGPT'
import SilvIA from './pages/SilvIA'
import AtendimentoAnalise from './pages/AtendimentoAnalise'
import ConfiguracoesAgendamentos from './pages/ConfiguracoesAgendamentos'
import ConfiguracoesNotificacoes from './pages/Configuracoes/Notificacoes'
import ConfiguracoesLogs from './pages/Configuracoes/Logs'
import ConfiguracoesMonitoramento from './pages/Configuracoes/Monitoramento'
import Whatsapp from './pages/Whatsapp'
import WikiArtigos from './pages/WikiArtigos'
import WikiGerenciar from './pages/WikiGerenciar'
import WikiBiblioteca from './pages/WikiBiblioteca'
import Circulando from './pages/Circulando'
import Imprensa from './pages/Imprensa'
import Interno from './pages/Interno'
import CRMDashboard from './pages/CRM/Dashboard'
import CRMContatos from './pages/CRM/Contatos'
import CRMEmpresas from './pages/CRM/Empresas'
import CRMOportunidadesKanban from './pages/CRM/OportunidadesKanban'
import CRMAtividades from './pages/CRM/Atividades'
import CRMRelatorios from './pages/CRM/Relatorios'
import ProjetosRoadmap from './pages/Projetos/Roadmap'
import ProjetosGestao from './pages/Projetos/Gestao'
import CCTLista from './pages/CCTLista'
import CCTImportar from './pages/CCTImportar'
import CCTCoberturasDicionario from './pages/CCTCoberturasDicionario'
import CCTSDashboardScgp from './pages/CCTSDashboardScgp'
import MensagensAtivas from './pages/MensagensAtivas'
import MiddlewareParceiros from './pages/MiddlewareParceiros'
import SuperappDashboard from './pages/SuperappDashboard'
import DashboardClientes from './pages/DashboardClientes'
import DashboardCorretor from './pages/DashboardCorretor'
import Shop from './pages/Shop'
import AgentesIAConsumo from './pages/AgentesIAConsumo'
import Zendesk from './pages/Zendesk'
import AgentesIAAgenteZendesk from './pages/AgentesIAAgenteZendesk'
import GerarAudio from './pages/GerarAudio'
import ComercialCupons from './pages/Comercial/Cupons'
import ComercialGestao from './pages/Comercial/Gestao'
import AdmDespesas from './pages/Adm/Despesas'
import AdmCadastros from './pages/Adm/Cadastros'
import AdmDashboard from './pages/Adm/Dashboard'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import './App.css'

function App() {
  useEffect(() => {
    document.title = 'PASI QG'
  }, [])
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/test-reset" element={<TestReset />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/atendimentos/resposta-zendesk" element={
              <ProtectedRoute>
                <AgentesIAAgenteZendesk />
              </ProtectedRoute>
            } />
            <Route path="/configuracoes/consumo" element={
              <ProtectedRoute>
                <AgentesIAConsumo />
              </ProtectedRoute>
            } />
            <Route path="/configuracoes/usuarios" element={
              <ProtectedRoute>
                <Usuarios />
              </ProtectedRoute>
            } />
            <Route path="/configuracoes/modulo" element={
              <ProtectedRoute>
                <ConfiguracoesModulos />
              </ProtectedRoute>
            } />
            <Route path="/configuracoes/portalatendimento" element={
              <ProtectedRoute>
                <ConfiguracoesPortalAtendimento />
              </ProtectedRoute>
            } />
            <Route path="/superapp/middleware-parceiros" element={
              <ProtectedRoute>
                <MiddlewareParceiros />
              </ProtectedRoute>
            } />
            <Route path="/superapp/dashboard" element={
              <ProtectedRoute>
                <SuperappDashboard />
              </ProtectedRoute>
            } />
            <Route path="/ccts/lista" element={
              <ProtectedRoute>
                <CCTLista />
              </ProtectedRoute>
            } />
            <Route path="/ccts/coberturas-dicionario" element={
              <ProtectedRoute>
                <CCTCoberturasDicionario />
              </ProtectedRoute>
            } />
            <Route path="/ccts/importar" element={
              <ProtectedRoute>
                <CCTImportar />
              </ProtectedRoute>
            } />
            <Route path="/ccts/dashboardscgp" element={
              <ProtectedRoute>
                <CCTSDashboardScgp />
              </ProtectedRoute>
            } />
            <Route path="/documentos/leitor" element={
              <ProtectedRoute>
                <LeitorArquivos />
              </ProtectedRoute>
            } />
            <Route path="/pasigpt" element={
              <ProtectedRoute>
                <PasiGPT />
              </ProtectedRoute>
            } />
            <Route path="/atendimentos/silvia" element={
              <ProtectedRoute>
                <SilvIA />
              </ProtectedRoute>
            } />
            <Route path="/atendimentos/whatsapp" element={
              <ProtectedRoute>
                <Whatsapp />
              </ProtectedRoute>
            } />
            <Route path="/atendimentos/zendesk" element={
              <ProtectedRoute>
                <Zendesk />
              </ProtectedRoute>
            } />
            <Route path="/portais/dashboard_cliente" element={
              <ProtectedRoute>
                <DashboardClientes />
              </ProtectedRoute>
            } />
            <Route path="/portais/dashboard_corretor" element={
              <ProtectedRoute>
                <DashboardCorretor />
              </ProtectedRoute>
            } />
            <Route path="/portais/shop" element={
              <ProtectedRoute>
                <Shop />
              </ProtectedRoute>
            } />
            <Route path="/atendimentos/analise" element={
              <ProtectedRoute>
                <AtendimentoAnalise />
              </ProtectedRoute>
            } />
            <Route path="/configuracoes/agendamentos" element={
              <ProtectedRoute>
                <ConfiguracoesAgendamentos />
              </ProtectedRoute>
            } />
            <Route path="/configuracoes/notificacoes" element={
              <ProtectedRoute>
                <ConfiguracoesNotificacoes />
              </ProtectedRoute>
            } />
            <Route path="/configuracoes/logs" element={
              <ProtectedRoute>
                <ConfiguracoesLogs />
              </ProtectedRoute>
            } />
            <Route path="/configuracoes/monitoramento" element={
              <ProtectedRoute>
                <ConfiguracoesMonitoramento />
              </ProtectedRoute>
            } />
            <Route path="/wiki" element={
              <ProtectedRoute>
                <WikiArtigos />
              </ProtectedRoute>
            } />
            <Route path="/wiki/artigos" element={
              <ProtectedRoute>
                <WikiArtigos />
              </ProtectedRoute>
            } />
            <Route path="/wiki/gerenciar" element={
              <ProtectedRoute>
                <WikiGerenciar />
              </ProtectedRoute>
            } />
            <Route path="/wiki/biblioteca" element={
              <ProtectedRoute>
                <WikiBiblioteca />
              </ProtectedRoute>
            } />
            {/* CRM */}
            <Route path="/crm" element={
              <ProtectedRoute>
                <CRMDashboard />
              </ProtectedRoute>
            } />
            <Route path="/crm/contatos" element={
              <ProtectedRoute>
                <CRMContatos />
              </ProtectedRoute>
            } />
            <Route path="/crm/empresas" element={
              <ProtectedRoute>
                <CRMEmpresas />
              </ProtectedRoute>
            } />
            <Route path="/crm/oportunidades" element={
              <ProtectedRoute>
                <CRMOportunidadesKanban />
              </ProtectedRoute>
            } />
            <Route path="/crm/atividades" element={
              <ProtectedRoute>
                <CRMAtividades />
              </ProtectedRoute>
            } />
            <Route path="/crm/relatorios" element={
              <ProtectedRoute>
                <CRMRelatorios />
              </ProtectedRoute>
            } />
            <Route path="/informativo/circulando" element={
              <ProtectedRoute>
                <Circulando />
              </ProtectedRoute>
            } />
            <Route path="/informativo/imprensa" element={
              <ProtectedRoute>
                <Imprensa />
              </ProtectedRoute>
            } />
            <Route path="/informativo/interno" element={
              <ProtectedRoute>
                <Interno />
              </ProtectedRoute>
            } />
            {/* Projetos */}
            <Route path="/projetos/roadmap" element={
              <ProtectedRoute>
                <ProjetosRoadmap />
              </ProtectedRoute>
            } />
            <Route path="/projetos/gestao" element={
              <ProtectedRoute>
                <ProjetosGestao />
              </ProtectedRoute>
            } />
            <Route path="/atendimentos/mensagens-ativas" element={
              <ProtectedRoute>
                <MensagensAtivas />
              </ProtectedRoute>
            } />
            <Route path="/ferramentas/gerar-audio" element={
              <ProtectedRoute>
                <GerarAudio />
              </ProtectedRoute>
            } />
            <Route path="/comercial" element={<ProtectedRoute><Navigate to="/comercial/gestao" replace /></ProtectedRoute>} />
            <Route path="/comercial/gestao" element={
              <ProtectedRoute>
                <ComercialGestao />
              </ProtectedRoute>
            } />
            <Route path="/comercial/cupons" element={
              <ProtectedRoute>
                <ComercialCupons />
              </ProtectedRoute>
            } />
            <Route path="/adm/despesas" element={
              <ProtectedRoute>
                <AdmDespesas />
              </ProtectedRoute>
            } />
            <Route path="/adm/cadastros" element={
              <ProtectedRoute>
                <AdmCadastros />
              </ProtectedRoute>
            } />
            <Route path="/adm/dashboard" element={
              <ProtectedRoute>
                <AdmDashboard />
              </ProtectedRoute>
            } />
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  )
}

export default App
